export enum pageTypeEnum{
   
    son_sayi="son_sayi",
    bilimsel_Kategoriler="scientific_categories",
    arsiv="arsiv",
    content="content"
  

}

export enum linkTypeEnum{
   
    externalLink="0",    
    sliderContentDetay="1", 
    pageContentLink="2"
  

}